'use client';
import { PlanPicker } from '@/components/stripe/PlanPicker';

export function PricingTables() {
  return <PlanPicker />;
}
